export const actions = {
  DELETE: 'DELETE',
  UPSERT: 'UPSERT',
  GET: 'GET',
  LIST: 'LIST',
  GET_QUEUES: 'GET_QUEUES',
  GET_NUMBERS: 'GET_NUMBERS',
  GET_TIMEZONES: 'GET_TIMEZONES',
  LOADING_CLOSURES: 'LOADING_CLOSURES',
  LOADING_PROMPTS: 'LOADING_PROMPTS',
  DELETING_CLOSURES: 'DELETING_CLOSURES',
  LIST_PROMPTS: 'LIST_PROMPTS',
  SET_ERROR: 'SET_ERROR',
  SET_MESSAGE: 'SET_MESSAGE',
};

export function reducer(state: any, action: any) {
  switch (action.type) {
    case actions.DELETE: {
      // @todo Potentially remove menu from list instead of listing again
      return {
        ...state,
        deletingClosures: false,
      };
    }
    case actions.DELETING_CLOSURES: {
      // @todo Potentially remove menu from list instead of listing again
      return {
        ...state,
        deletingClosure: action.payload,
      };
    }
    case actions.UPSERT: {
      // @todo Potentially append menu in list instead of listing again
      return state;
    }
    case actions.LOADING_CLOSURES: {
      return {
        ...state,
        loadingClosures: action.payload,
      };
    }
    case actions.LOADING_PROMPTS: {
      return {
        ...state,
        loadingPrompts: action.payload,
      };
    }
    case actions.LIST: {
      return {
        ...state,
        closuresLoaded: true,
        loadingClosures: false,
        closuresList: action.payload.closuresList,
      };
    }
    case actions.LIST_PROMPTS: {
      return {
        ...state,
        loadingPrompts: false,
        promptsLoaded: true,
        prompts: action.payload.prompts,
      };
    }
    case actions.GET_QUEUES:
      return {
        ...state,
        queuesLoaded: true,
        queues: action.payload.queues,
      };
    case actions.GET_NUMBERS:
      return {
        ...state,
        numbersLoaded: true,
        numbers: action.payload.numbers,
      };
    case actions.GET_TIMEZONES:
      return {
        ...state,
        timezonesLoaded: true,
        timezones: action.payload.timezones,
      };
    case actions.SET_MESSAGE:
      return {
        ...state,
        msg: action.payload.msg,
      };
    default:
      return state;
  }
}
